import Cookies from 'js-cookie';

export default function cookieConsent(
  gtagId,
  cookieName = 'cookie_notice_accepted',
  acceptedCookieExpiration = 365,
  declinedCookieExpiration = 30,
  onAccepted = () => {}
) {
  // modal not presented before (or cookie expired)
  const cookie = Cookies.get(cookieName);

  const appendTrackingCode = () => {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-${gtagId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', `G-${gtagId}`);
  };

  // modal not presented before (or cookie expired)
  if (cookie === undefined) {
    const modal = document.querySelector('.cookie-consent');
    const acceptBtn = document.querySelector('.cookie-consent__accept');
    const closeBtn = document.querySelector('.cookie-consent__close');
    const declineBtn = document.querySelector('.cookie-consent__decline');
    modal.classList.add('cookie-consent--show');

    // set cookie to remember user's choice & hide modal
    const acceptCookies = () => {
      Cookies.set(cookieName, 'true', { expires: acceptedCookieExpiration });
      modal.classList.remove('cookie-consent--show');
      acceptBtn.removeEventListener('click', acceptCookies);
      appendTrackingCode();
      onAccepted();
    };

    const declineCookies = () => {
      Cookies.set(cookieName, 'false', { expires: declinedCookieExpiration });
      modal.classList.remove('cookie-consent--show');
      declineBtn.removeEventListener('click', declineCookies);
      closeBtn.removeEventListener('click', declineCookies);
    };

    acceptBtn.addEventListener('click', acceptCookies);
    declineBtn.addEventListener('click', declineCookies);
    closeBtn.addEventListener('click', declineCookies);
  } else if (cookie === 'true') {
    appendTrackingCode();
  }
}
